/*
* PdfTextContent.js
* Created on 22-11-2017
* @author Olivier for &ranj
*/

import { isNull } from "../../../util/TypeUtil";
import AbstractPdfContent from "./AbstractPdfContent";

export default class PdfTextContent extends AbstractPdfContent {
    constructor(text, style) {
        super(style);
        
        this._font = { family: 'helvetica', size: 12, color: [0, 0, 0], style: "normal" };
        this._text = text;

        this.setPropertiesFromObject(style);
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("font"): this._font.family = obj[property]; break;
                    case ("size"): this._font.size = obj[property]; break;
                    case ("style"): this._font.style = obj[property]; break;
                    case ("align"): this._font.align = obj[property]; break;
                    case ("color"): this._font.color = obj[property]; break;
                }
            }
        }
    }

    calculateBounds(doc) {
        //console.log("Calculating text bounds of " + this._text);
        doc.setFont(this._font.family, this._font.style);
        doc.setFontSize(this._font.size);

        let texts = this._text.split("\r");
        let width = 0;
        let height = 0;
        let lines = 0;

        for (let x = texts.length - 1; x >= 0; x--) {
            if (texts[x].length === 0) texts.splice(x, 1); //remove empty texts caused by the string splitting
        }

        this._splitText = [];
        for (let x = 0; x < texts.length; x++) {
            if (this._width > 0) {
                //width is defined but height is not. Calculate height based on width
                let split = doc.splitTextToSize(texts[x], this._width - this._padding[1] - this._padding[3]);
                this._splitText.push(split);
                lines += split.length;
            } else {
                //width is not defined, calculate both width and height
                let dimensions = doc.getTextDimensions(texts[x]);
                width = Math.max(width, dimensions.w);
                height += dimensions.h;
                this._splitText.push(texts[x]);
            }
        }

        if (this._width > 0) {
            height = lines * this._font.size;
        } else {
            this.setWidth(width * 96 / 72 / 2); //width is calculated in points, this formula converts it to pixels (but the results are a bit wonky...)
        }

        this.setHeight(height);
    }

    printToDocument(doc, x, y) {
        super.printToDocument(doc, x, y);
        //console.info("Drawing text " + this._text + " at " + x + ", " + y);

        let top = y + (this._font.size * 0.5) + this._padding[0];
        let left = x + this._padding[3];

        if (this._font.align === "center") left += this._width / 2;
        if (this._font.align === "right") left += this._width - this._padding[1] - this._padding[3];
        if (this._font.align === "left") this._font.align = null;

        doc.setFont(this._font.family, this._font.style);
        doc.setFontSize(this._font.size);
        doc.setTextColor(this._font.color[0], this._font.color[1], this._font.color[2]);
        let lines = 0;
        for (let i = 0; i < this._splitText.length; i++) {
            if (isNull(this._font.align)) {
                doc.text(this._splitText[i], left, top + (this._font.size * lines));
            } else {
                doc.text(this._splitText[i], left, top + (this._font.size * lines), this._font.align);
            }

            if (this._splitText[i] instanceof Array) {
                lines += this._splitText[i].length;
            } else {
                lines++;
            }
        }
    }
}